import { GrantsModel } from 'src/app/core/models/grants.model';
import { Scope } from 'src/app/core/enums/scopes.enum';
import { environment } from 'src/environments/environment';

export class FakeGrants implements GrantsModel {
  public patronType;
  public role;
  public permissions;
  public scopes;
  public imsRole;
  public persona;

  constructor() {
    if (environment.production) return; 'PORTAL_TEST_CODE'; // eslint-disable-line


    this.imsRole = 'ADMINISTRATOR';
    this.persona = 'OTHER';

    this.patronType = { id: 303, name: 'Faculty'};
    this.role = {id: 5724, name: 'Administrator', sessionTimeoutMillis: 300000};
    this.permissions = [
      'GenerateReportsAsset',
      'WebPathExpressSearch',
      'AEDCustomPatronReports',
      'BarcodeSearch',
      'SetupOneSearch',
      'InventoryAssetTransfer',
      'RecommendTitlesApproveEditDelete',
      'ReassignResources',
      'CatAssetEditAssetSpec',
      'viewNewLeafCommunity',
      'InventoryCollection',
      'BriefSearch',
      'InventoryTextbookCollection',
      'DashboardShowTextbook',
      'Checkout',
      'FinesAddAsset'
    ];
    this.scopes = [
      Scope.LIBRARY_ACCESS,
      Scope.DESTINY_BACKOFFICE_ACCESS,
      // Scope.RESOURCE_ACCESS,
      Scope.COMMUNITY_ACCESS,
      Scope.DISCOVER_ACCESS,
      Scope.TITLEWAVE_ACCESS,
      Scope.DISCOVER_ADMIN
      // Scope.LIBRARY_ADMIN,
      // Scope.RESOURCE_ADMIN
    ];
  }
}
